<template>
    <div class="branches box">
        <h2>{{ t('places-branches-title') }}</h2>
        <branch-form />
        <table class="table table--list">
            <thead>
                <tr>
                    <th>{{ t('id') }}</th>
                    <th>{{ t('title') }}</th>
                    <th>{{ t('places-branches-neighborhood_city') }}</th>
                    <th>{{ t('phone') }}</th>
                    <th>{{ t('email') }}</th>
                    <th>{{ t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="branch in branches" :key="branch.id">
                    <td>{{ branch.id }}</td>
                    <td>{{ branch.title }}</td>
                    <td>{{ branch.zone }} / {{ branch.city }}</td>
                    <td>{{ branch.phone }}</td>
                    <td>{{ branch.email }}</td>
                    <td>
                        <button
                            class="bnt btn-primary"
                            @click="editBranch(branch.id)"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <button class="btn btn-primary pull-right" @click="addBranch()">
            {{ t('places-branches-add_branch') }}
        </button>
        <div class="clear"></div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import BranchForm from "./form";
export default {
    components: {
        BranchForm,
    },
    computed: mapState({
        branches: (state) => state.placeDetails.branches,
    }),
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        ...mapActions({
            addBranch: "placeDetails/addBranch",
            editBranch: "placeDetails/editBranch",
        }),
    },
};
</script>
